export default class UserService {
    static getAvatarLinkByFilename(filename) {
        return '/assets/dipocaco/avatars/' + filename
    }
}
